export default "__VITE_ASSET__kPe08kDc__"